import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ScrollText } from 'lucide-react';
import type { EntradaBitacora } from '@doc/shared';
import { api } from '../../lib/api.js';
import { ETIQUETA_ACCION, fecha } from '../../lib/formato.js';
import { Cabecera } from '../../layout/Marco.js';

const ACCIONES = Object.keys(ETIQUETA_ACCION);

export function BitacoraPage() {
  const [accion, setAccion] = useState('');

  const { data, isLoading } = useQuery({
    queryKey: ['bitacora', accion],
    queryFn: () => api<EntradaBitacora[]>(`/bitacora?limite=200${accion ? `&accion=${accion}` : ''}`),
  });

  return (
    <>
      <Cabecera
        titulo="Bitácora"
        subtitulo="Quién hizo qué y sobre qué documento"
        acciones={
          <select className="select" style={{ width: 220 }} value={accion} onChange={(e) => setAccion(e.target.value)}>
            <option value="">Todas las acciones</option>
            {ACCIONES.map((a) => (
              <option key={a} value={a}>
                {ETIQUETA_ACCION[a]}
              </option>
            ))}
          </select>
        }
      />

      <div className="pagina">
        {isLoading && <div className="cargando">Cargando…</div>}

        {data && data.length === 0 && (
          <div className="vacio">
            <div className="icono">
              <ScrollText size={36} />
            </div>
            <p>Sin registros para este filtro.</p>
          </div>
        )}

        {data && data.length > 0 && (
          <table className="tabla">
            <thead>
              <tr>
                <th style={{ width: 175 }}>Fecha</th>
                <th style={{ width: 180 }}>Acción</th>
                <th style={{ width: 170 }}>Usuario</th>
                <th>Documento</th>
                <th style={{ width: 130 }}>IP</th>
              </tr>
            </thead>
            <tbody>
              {data.map((e) => (
                <tr key={e.id}>
                  <td className="muted">{fecha(e.creadoEn)}</td>
                  <td>
                    <span className={`badge${e.accion === 'LOGIN_FALLIDO' ? '' : ' badge--verde'}`}>
                      {ETIQUETA_ACCION[e.accion] ?? e.accion}
                    </span>
                  </td>
                  <td>{e.usuarioNombre ?? '—'}</td>
                  <td className="muted" style={{ fontSize: 12 }}>
                    {e.nodoRuta ?? (e.detalle ? JSON.stringify(e.detalle) : '—')}
                  </td>
                  <td className="dim" style={{ fontSize: 11.5 }}>
                    {e.ip ?? '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
